import { makeStyles } from '@material-ui/core';
import { useSidebarOpenState } from '@backstage/core-components';
import CallMadeIcon from '@material-ui/icons/CallMade';

/**
 * The other AnswerRocket sites, in the rail's lower section.
 *
 * Same set and order as the wiki's top bar (`wiki/lib/site-config.ts`, under
 * "AnswerRocket tools"), minus the Catalog itself. They are links OUT, so they
 * look it: a small heading saying so, a ↗ on every row, and a new tab — the
 * thing a person had open here is still here when they come back.
 *
 * Plain anchors rather than SidebarItem: SidebarItem routes in-app, marks
 * itself active by path, and would draw these exactly like the pages above
 * them, which is the confusion the heading is there to prevent.
 */
const LINKS = [
  { title: 'Launchpad', href: 'https://launchpad.answerrocket.com' },
  { title: 'Wiki', href: 'https://wiki.answerrocket.com' },
  { title: 'Control', href: 'https://control.answerrocket.com' },
  { title: 'DevOps requests', href: 'https://devops.answerrocket.com' },
];

const useStyles = makeStyles({
  root: { padding: '10px 10px 6px', width: '100%' },
  heading: {
    fontFamily: 'var(--ar-font-mono)',
    fontSize: '0.625rem',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: 'var(--ar-fg-3)',
    padding: '0 10px 6px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    height: 32,
    padding: '0 10px',
    borderRadius: 8,
    fontSize: '0.8125rem',
    fontWeight: 520,
    color: 'var(--ar-fg-2)',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'var(--ar-surface-2)',
      color: 'var(--ar-fg)',
    },
    '&:hover $arrow': { color: 'var(--ar-accent)' },
  },
  label: { flex: 1 },
  arrow: { fontSize: 14, color: 'var(--ar-fg-3)' },
});

export const EcosystemLinks = () => {
  const classes = useStyles();
  const { isOpen } = useSidebarOpenState();
  // Collapsed (an unpinned rail, or the mobile bar) there is no room for a
  // labelled list, and four bare ↗ icons say nothing.
  if (!isOpen) return null;
  return (
    <nav className={classes.root} aria-label="Other AnswerRocket sites">
      <div className={classes.heading}>AnswerRocket sites</div>
      {LINKS.map(link => (
        <a
          key={link.href}
          className={classes.link}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={classes.label}>{link.title}</span>
          <CallMadeIcon className={classes.arrow} aria-hidden />
          <span style={{ position: 'absolute', left: -9999 }}>
            (opens in a new tab)
          </span>
        </a>
      ))}
    </nav>
  );
};
